
import { Component, Vue, Prop } from "vue-property-decorator";

import defaultAvatar from "@/assets/images/ic_nol_man.png";
import { formatAvatar } from "@/utils";

@Component({
  name: "avatar"
})
export default class Avatar extends Vue {
  @Prop() private src!: string;
  @Prop() private width!: string;
  @Prop() private height!: string;
  @Prop({ default: "auto" }) private mode!: boolean;

  defaultUrl = formatAvatar;
  defaultAvatar = defaultAvatar;

  // mounted () {
  //   this.formatAvatar = process.env.VUE_APP_BASE_API + this.src
  // }
}
